<template>
    <label class="form-radio form-control"
           :class="classes"
    >
        <slot></slot>

        <div class="form-radio__input-container">
            <BaseRadio :value="value"
                       :model-value="modelValue"
                       @update:model-value="update"
                       class="form-control__input"
            />
        </div>
    </label>
</template>

<script>
    export default {
        props: {
            value: null,
            modelValue: null,
        },

        computed: {
            checked() {
                return this.modelValue === this.value;
            },

            classes() {
                return this.checked ? ['border-midnight'] : ['border-swiss-coffee'];
            }
        },

        methods: {
            update() {
                this.$emit('update:modelValue', this.value);
            }
        }
    }
</script>

<style>
.form-radio {
    @apply cursor-pointer relative block w-full p-4 border rounded-sm transition duration-300;

    &__input-container {
        @apply absolute top-4 right-4;
    }
}
</style>
